/**
 * runidea.ai — Phase 14 Wave 3 — Maintenance-mode overlay.
 *
 * Listens for the global `runidea:maintenance` event (dispatched by the
 * axios response interceptor when the backend returns 503 with
 * `{maintenance: true}`). When fired, shows a full-page overlay so the
 * user can't interact with stale UI.
 */
import { useEffect, useState } from "react";
import { Wrench } from "lucide-react";

export default function MaintenanceOverlay() {
  const [on, setOn] = useState(false);
  const [message, setMessage] = useState("");
  useEffect(() => {
    const handler = (e) => {
      setOn(true);
      setMessage(e?.detail?.message || "");
    };
    window.addEventListener("runidea:maintenance", handler);
    return () => window.removeEventListener("runidea:maintenance", handler);
  }, []);
  if (!on) return null;
  return (
    <div
      data-testid="maintenance-overlay"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/95 px-6 backdrop-blur"
    >
      <div className="max-w-md rounded-2xl border border-slate-700 bg-slate-800 p-8 text-center text-slate-100 shadow-2xl">
        <div className="mx-auto mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-amber-500/20 text-amber-400">
          <Wrench className="h-5 w-5" />
        </div>
        <h2 className="text-xl font-bold">We&apos;ll be right back</h2>
        <p className="mt-2 text-sm leading-relaxed text-slate-300">
          {message || "RunIdea is undergoing scheduled maintenance. Please try again in a few minutes."}
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          data-testid="maintenance-retry"
          className="mt-5 inline-flex items-center gap-1.5 rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold hover:bg-indigo-500"
        >
          Retry
        </button>
      </div>
    </div>
  );
}
